import { AboutSection } from './AboutSection';
import { Checkout } from './Checkout';
import { ConfirmationCode } from './ConfirmationCode';
import { Dish } from './Dish';
import { EditProfile } from './EditProfile';
import { Filter } from './Filter';
import { ForgotPassword } from './ForgotPassword';
import { ForgotPasswordSentEmail } from './ForgotPasswordSentEmail';
import { LeaveAReview } from './LeaveAReview';
import { MenuList } from './MenuList';
import { MenuListAI } from './MenuListAI';
import { NewPassword } from './NewPassword';
import { Onboarding } from './Onboarding';
import { OrderFailed } from './OrderFailed';
import { OrderHistory } from './OrderHistory';
import { OrderHistoryEmpty } from './OrderHistoryEmpty';
import { OrderSuccessful } from './OrderSuccessful';
import { Promocodes } from './Promocodes';
import { PromocodesEmpty } from './PromocodesEmpty';
import { Reviews } from './Reviews';
import { Search } from './Search';
import { SignIn } from './SignIn';
import { SignUp } from './SignUp';
import { SignUpAccountCreated } from './SignUpAccountCreated';
import { TrackYourOrder } from './TrackYourOrder';
import { VerifyYourPhoneNumber } from './VerifyYourPhoneNumber';

export const screens = {
  Dish,
  SignIn,
  Search,
  SignUp,
  Filter,
  Reviews,
  MenuList,
  MenuListAI,
  Checkout,
  Onboarding,
  Promocodes,
  EditProfile,
  OrderFailed,
  NewPassword,
  LeaveAReview,
  OrderHistory,
  ForgotPassword,
  TrackYourOrder,
  OrderSuccessful,
  PromocodesEmpty,
  ConfirmationCode,
  OrderHistoryEmpty,
  SignUpAccountCreated,
  VerifyYourPhoneNumber,
  ForgotPasswordSentEmail,
  AboutSection
};
